import { addOrderApi_V2 } from '@/api/order.js'

function payInfoHandle(info) {
  const { payType, payInfo } = info

  if (payType === 'cart') {
    return {
      sourceType: 'carts_id',
      payGoodsInfo: `[${payInfo}]`
    }
  }

  if (payType === 'buyNow') {
    return {
      sourceType: 'goods_sn',
      payGoodsInfo: payInfo[0]
    }
  }
}

/**
 * @typedef {Object} options
 * @property {string} goods_sn - 商品编号
 * @property {number} paymentType - 支付方式（1 积分支付 | 2 余额支付 | 3 微信支付 | 20 混合支付)
 * @property {string} remark - 备注（可选）
 * @property {string} distribution_date - 配送日期（可选）
 * @property {string} distribution_time - 配送时间（可选）
 * @property {string} distribution_type - 配送方式（可选）
 * @property {string} address_id - 配送地址（必选）
 * @property {string} goods_type - 蛋糕类型（可选）(4 蛋糕)
 * @property {string} shop_id - 自提门店id
 *
 */

async function addOrderByGoods(
  { state, commit },
  options = {}
) {
  const { paymentType, remark } = options
  const { sourceType, payGoodsInfo } = payInfoHandle({
    payType: state.payType,
    payInfo: state.payInfo
  })

  const result = await addOrderApi_V2({
    [sourceType]: payGoodsInfo,
    payment_type: paymentType,
    remark: remark,
    address_id: state.addressId
  })
  return result.data.data
}

/**
 * @typedef {Object} options
 * @property {string} goods_sn - 商品编号
 * @property {number} paymentType - 支付方式（1 积分支付 | 2 余额支付 | 3 微信支付 | 20 混合支付)
 * @property {string} remark - 备注（可选）
 * @property {string} distribution_date - 配送日期（可选）
 * @property {string} distribution_time - 配送时间（可选）
 * @property {string} distribution_type - 配送方式（可选）
 * @property {string} address_id - 配送地址（必选）
 * @property {string} goods_type - 蛋糕类型（可选）(4 蛋糕)
 * @property {string} cake_addr - 蛋糕地址（可选）
 * @property {string} shop_id - 自提门店id
 * @property {string} shop_name - 自提门店名称
 * @property {string} shop_address - 自提门店地址
 */

async function addOrderByCake(
  { state, getters, dispatch },
  options = {}
) {
  const {
    distribution_date,
    distribution_time,
    distribution_type,
    paymentType,
    remark,
    goods_type,
    cake_addr,
    shop_id,
    shop_address,
    shop_name
  } = options
  const result = await addOrderApi_V2({
    address_id: state.addressId,
    goods_sn: state.payInfo[0].goods_size[0],
    remark: remark || undefined,
    payment_type: paymentType,
    distribution_date: distribution_date,
    distribution_time: distribution_time,
    distribution_type: distribution_type || undefined,
    goods_type: goods_type || undefined,
    cake_addr: cake_addr || undefined,
    shop_id: shop_id,
    shop_name: shop_name,
    shop_address: shop_address
  })
  return result.data.data
}

function orderAdd({ commit, state }, params) {
  if (params.pay_goods_type === 'cake') {
    return addOrderByCake({ commit, state }, params)
  }

  if (params.pay_goods_type === 'goods') {
    return addOrderByGoods({ commit, state }, params)
  }
}

export default orderAdd
